
import { supabase } from "@/integrations/supabase/client";

export const useProfileDebug = () => {
  const debugProfileReports = async () => {
    try {
      console.log('🐛 Starting debug session...');
      
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) return;

      const { data: profile } = await supabase
        .from('profiles')
        .select('id, location, latitude, longitude')
        .eq('user_id', user.id)
        .single();

      if (!profile) {
        console.log('❌ No profile found');
        return;
      }

      console.log('🔍 Current Profile Info:', profile);

      if (profile.location && (!profile.latitude || !profile.longitude)) {
        console.log('⚠️ Location exists but coordinates are missing');
        console.log('⚠️ This suggests the database trigger may not have fired or location format is not recognized');
        
        const { data: testCoords } = await supabase
          .rpc('get_coordinates_from_location_text' as any, { location_text: profile.location });
        
        console.log('🧪 Test coordinate lookup result:', testCoords);
        
      } else if (profile.latitude && profile.longitude) {
        console.log('✅ Coordinates are populated:', {
          latitude: profile.latitude,
          longitude: profile.longitude
        });
      }

      const { data: allReports } = await supabase
        .from('usda_reports')
        .select('count(*)')
        .single();

      console.log('📊 Total USDA reports in database:', allReports);

      const { data: profileReports } = await supabase
        .from('profile_reports')
        .select('*')
        .eq('profile_id', profile.id);

      console.log('📊 Profile reports found:', profileReports?.length || 0);
      if (profileReports?.length) {
        console.log('Sample profile reports:', profileReports.slice(0, 3));
      }

    } catch (error) {
      console.error('Debug error:', error);
    }
  };

  return {
    debugProfileReports
  };
};
